var render = function render(){var _vm=this,_c=_vm._self._c;return _c('mapa-google',{ref:"GoogleMaps",attrs:{"coordenadas":_vm.coordenadas,"coordenadas-entrada":_vm.coordenadas,"desactivar-mapa":true,"icono-central":`/img/icons/${_vm.icono}`,"dragable":false,"height":_vm.heightMapa,"width":"100%"},on:{"actualizar":_vm.actualizarCoordenadas}})
}
var staticRenderFns = []

export { render, staticRenderFns }